export default (str, splitByWords = true, limit, after) => {
  if (str) {
    let content
    if (splitByWords) {
      const splitContent = str.split(" ")
      content = str
        .split(" ")
        .slice(0, limit)
        .join(" ")
      if (splitContent.length > limit) {
        content = content + (after ? after : "")
      }
    } else {
      content = str.slice(0, limit)
      content = content + (after ? after : "")
    }
    return content
  }
}



// WEBPACK FOOTER //
// ./src/utils/textTruncate.js